import api from '../lib/api'

//662.125.880-15
/*
<?xml version="1.0" encoding="UTF-8"?>
<mensagem>
    <erro>
        <descricao>Nao encontrato inquilino ativo com esse CPF/CNPJ</descricao>
    </erro>
</mensagem>
*/
/*
<?xml version="1.0" encoding="UTF-8"?>
<boletos>
    <boleto>
        <sistema>A</sistema>
        <codigo>9209275</codigo>
        <codigoCliente>41538</codigoCliente>
        <cpfCnpj>66212588015</cpfCnpj>
        <nome>NEIDE DA COSTA DUTRA</nome>
        <tipoDOC>A</tipoDOC>
        <competencia>03/2020</competencia>
        <dataVencimento>10/04/2020</dataVencimento>
        <atualizarVencimento>N</atualizarVencimento>
        <valor>138,37</valor>
        <valorJMC>0,00</valorJMC>
        <valorAtualizado>138,37</valorAtualizado>
        <imovel>
            <codigo>51831</codigo>
            <subcodigo>15771</subcodigo>
            <tipo>BOX</tipo>
            <endereco> 
                <rua>SAO JOAQUIM</rua>
                <numero>611</numero>
                <bairro>CENTRO</bairro>
                <cidade>SAO LEOPOLDO</cidade>
                <uf>RS</uf>
                <cep>93010190</cep>
                <complemento>BOX 221</complemento>
                <enderecoCompleto>SAO JOAQUIM, 611/BOX 221 - CENTRO - SAO LEOPOLDO - RS</enderecoCompleto>
            </endereco>
            <filial>
                <codigo>6</codigo>
                <abrev>SL</abrev>
                <descricao>SÃO LEOPOLDO</descricao>
                <empresa>1</empresa>
            </filial>
        </imovel>
    </boleto>
</boletos>
*/

export default {
    async getBoletos({ commit }, { cpf_cnpj, empresa = 1 }) {
        switch (empresa) {
            case 1:
            case "1":
            case "Vila Rica":
                empresa = 1;
                break;
            case 2:
            case "2":
            case "São Luiz":
                empresa = 2;
            default:
                break;
        }

        let cpfCnpj = cpf_cnpj.replace(/\D+/gim, "");


        return api
            .get("/aluguel/listaBoletos", {
                cpfCnpj,
                empresa,
            })
            .then(({ boletos }) => boletos.boleto)
            .then(boletos => {             
                if ('undefined' === typeof boletos) {
                    return [];
                }
                if (!(boletos instanceof Array) && 0 !== Object.keys(boletos).length) {
                    console.log(typeof boletos, boletos instanceof Array, Object.keys(boletos).length);   
                    boletos = [boletos];
                    
                } else if (0 === Object.keys(boletos).length) {
                    boletos = [];
                }
                return boletos;
            })
            .then(boletos => {
                commit('setBoletos', boletos);
            }).catch(err => {
                console.log(err);
                if (err.response && err.response.data) {
                    throw new Error(err.response.data.error)
                }
                throw err;
            })
    }
};
